/**
 * Skills runtime — re-exports the validated JSON data layer.
 * Skill combat mechanics (XP per tick, level curve) live in ./xp.ts.
 */
import type { ItemId } from '../state';
import { SKILLS_BY_ID, SKILLS_DATA } from '../../data';

export type SkillRing = 'combat' | 'gathering' | 'crafting' | 'artisan' | 'support';

export type SkillSpec = (typeof SKILLS_DATA.skills)[number];
export type { ItemId };

export const SKILLS: ReadonlyArray<SkillSpec> = SKILLS_DATA.skills;
export { SKILLS_BY_ID };

export function getSkill(id: SkillSpec['id']): SkillSpec {
  const s = SKILLS_BY_ID.get(id);
  if (!s) throw new Error(`Unknown skill: ${id}`);
  return s;
}